// Mirrors the roles that hold security_group.* in rbac-service; the permission check still applies.
export const SECURITY_ADMIN_ROLES: string[] = ['admin', 'ssh_admin', 'super_admin'];
